import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_API_URL || '/api';

export default function GdprPage({ onClose }) {
  const { lang, t } = useAuth ? useAuth() : { lang: 'cs', t: k => k };
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/pages/gdpr`)
      .then(r => r.json())
      .then(setPage)
      .finally(() => setLoading(false));
  }, []);

  const title = page ? (page[`title_${lang}`] || page.title_cs) : '';
  const content = page ? (page[`content_${lang}`] || page.content_cs) : '';

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5', fontFamily: "'Outfit','Segoe UI',sans-serif", padding: '40px 16px' }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');`}</style>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: '40px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>Načítám...</div>
          ) : (
            <>
              <h1 style={{ margin: '0 0 24px', fontSize: 28, fontWeight: 800, color: '#111827' }}>{title}</h1>
              <div style={{ fontSize: 15, color: '#374151', lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>{content}</div>
            </>
          )}
          {onClose && (
            <button onClick={onClose} style={{ marginTop: 32, background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
              {t ? t('back') : 'Zpět'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
